<template>
  <v-snackbar v-model="open" class="ml-8" :color="color" :timeout="3000" left>
    <div class="snackbar">
      <span class="snackbar-text">{{ message }}</span>
      <v-icon class="cursor-pointer" color="branco" @click.stop="closeSnackbar()">close</v-icon>
    </div>
  </v-snackbar>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    snackbarColor: {
      type: String,
      default: 'primary'
    },
    message: {
      type: String,
      default: ''
    }
  },
  computed: {
    color() {
      const SNACKBAR_COLORS = {
        error: '#F15435',
        success: '#0A8533',
        primary: '#002040'
      }

      return SNACKBAR_COLORS[this.snackbarColor]
    },
    open: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    closeSnackbar(value) {
      this.open = false
    }
  }
}
</script>
<style lang="scss" scoped>
.snackbar {
  font-family: 'Lato', sans-serif;
  z-index: 999999 !important;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
}
.cursor-pointer {
  cursor: pointer;
}
</style>
